import { render, staticRenderFns } from "./MzNextGrid.vue?vue&type=template&id=6b47ca08&"
import script from "./MzNextGrid.vue?vue&type=script&lang=js&"
export * from "./MzNextGrid.vue?vue&type=script&lang=js&"
import style0 from "./MzNextGrid.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports